module.exports = __webpack_public_path__ + "static/media/parallax-bg-8.3ed47b87.jpg";